import { format } from 'date-fns';

/**
 * Округляет число до указанного количества десятичных знаков.
 * @param value Число для округления.
 * @param decimals Количество знаков после запятой (по умолчанию 2).
 * @returns Округленное число.
 */
function roundTo(value: number, decimals: number = 2): number {
  const factor = Math.pow(10, decimals);
  return Math.round(value * factor) / factor;
}

export function formatDate(date?: string): string {
  if (!date) return '';
  try {
    return format(new Date(date), 'dd.MM.yyyy');
  } catch (e) {
    return date;
  }
}

export function formatSum(value?: number | string): string | undefined {
  if (typeof value === 'string') {
    const num = parseFloat(value);
    if (isNaN(num)) return value;
    value = num;
  }

  if (typeof value !== 'number') {
    return value;
  }

  // Округляем до двух знаков после запятой
  const roundedValue = roundTo(value, 2);

  if (Math.abs(roundedValue) < 0.005) {
    return (0.00).toLocaleString('ru-RU', { 
      minimumFractionDigits: 2, 
      maximumFractionDigits: 2 
    });
  }

  return roundedValue.toLocaleString('ru-RU', { 
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2,
  });
}
export const formatDates = (date: string): string => {
  const d = new Date(date);
  return d.toLocaleDateString("ru-RU");
};

/**
 * Форматирование суммы:
 * - отбрасываем дробную часть
 * - добавляем букву "р"
 */
export const formatSums = (sum?: number | string): string => {
  // Приводим значение к числу
  const num = Number(sum);
  
  // Если результат не число (NaN), возвращаем пустую строку
  if (isNaN(num)) {
    return '';
  }

  // Форматируем число с двумя знаками после запятой и добавляем символ рубля
  return num.toLocaleString('ru-RU', { 
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2 
  }) + ' ₽';
};

export function formatPercent(value?: number | string): string {
  if (typeof value === 'number') {
    // Округляем до двух знаков и добавляем %
    const rounded = roundTo(value, 2).toFixed(2);
    return `${rounded}%`;
  }
  return '';
}

export function transformCalculationParametersData(data: any) {
  return data.map((item: any) => ({
    beginningOfPeriod: item['beginning of period'],
    endOfPeriod: item['end of period'],
    calculationType: item.calculationType,
    basicInterestRate: item.basicInterestRate,
    minimumInterestRate: item.minimumInterestRate,
  }));
}
